import React from 'react';
import PropTypes from 'prop-types';
import { AlertDialog, Flex, Text } from '@homeexchange/design';
import i18n from '../../../i18n';

const DeleteSuccessDialog = ({ isOpen, onClose }) => (
    <AlertDialog
        title={i18n.t('collection:modal.applicationCollection.applicationDeleted.title')}
        confirmActionText={i18n.t('collection:global.close')}
        isOpen={isOpen}
        onConfirmAction={onClose}
    >
        <Flex>
            <Text>{i18n.t('collection:modal.applicationCollection.applicationDeleted.body')}</Text>
        </Flex>
    </AlertDialog>
);

DeleteSuccessDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default DeleteSuccessDialog;
